export const toAbsoluteUrl = (pathname: string) => "" + pathname
